import moment from 'moment';
import React, { useEffect, useReducer, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import { Helmet } from 'react-helmet-async';
import { MdAttachMoney } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from '../../toasts';
import DetailPageLoader from '../../components/DetailPageLoader/DetailPageLoader';
import MessageBox from '../../components/MessageBox';
import Pagination from '../../components/Pagination';
import BillService from '../../services/bill.service';
import { getError } from '../../utils';
import { useLabels } from '../../hooks/useLabels';

const reducer = (state, action) => {
	switch (action.type) {
	case 'FETCH_REQUEST':
		return { ...state, loading: true };
	case 'FETCH_SUCCESS':
		return { ...state, bills: action.payload, loading: false };
	case 'FETCH_FAIL':
		return { ...state, loading: false, error: action.payload };
	case 'DELETE_REQUEST':
		return { ...state, loadingDelete: true, successDelete: false };
	case 'DELETE_SUCCESS':
		return {
			...state,
			loadingDelete: false,
			successDelete: true,
		};
	case 'DELETE_FAIL':
		return { ...state, loadingDelete: false, successDelete: false };

	case 'DELETE_RESET':
		return { ...state, loadingDelete: false, successDelete: false };
	default:
		return state;
	}
};

function BillsList() {
	const { t } = useLabels();
	const [{ loading, error, bills, successDelete }, dispatch] = useReducer(reducer, {
		bills: [],
		loading: true,
		error: '',
	});

	const navigate = useNavigate();

	//pagination
	const [currentPage, setCurrentPage] = useState(1);
	const [postsPerPage] = useState(15); //maxPostsperPage
	const indexOfLastPost = currentPage * postsPerPage;
	const indexOfFirstPost = indexOfLastPost - postsPerPage;
	const currentPosts = bills.slice(indexOfFirstPost, indexOfLastPost);
	//change page
	const paginate = (pageNumber) => setCurrentPage(pageNumber);

	const fetchData = async () => {
		try {
			dispatch({ type: 'FETCH_REQUEST' });

			const { data } = await BillService.list();
			dispatch({ type: 'FETCH_SUCCESS', payload: data });
		} catch (err) {
			dispatch({ type: 'FETCH_FAIL', payload: getError(err) });
		}
	};

	useEffect(() => {
		if (successDelete) {
			dispatch({ type: 'DELETE_RESET' });
		} else {
			fetchData();
		}
	}, [successDelete]);

	// Refresh when window gains focus (user returns from another page)
	useEffect(() => {
		const handleFocus = () => {
			fetchData();
		};
		window.addEventListener('focus', handleFocus);
		return () => {
			window.removeEventListener('focus', handleFocus);
		};
	}, []);

	async function verComprobante(bill) {
		if (bill.comprobante) {
			window.open(bill.comprobante.fileLink, '_blank', 'noopener,noreferrer');
		}
	}

	async function deletePaymentHandler(bill) {
		if (window.confirm(t('msg.confirmDeleteBill'))) {
			try {
				dispatch({ type: 'DELETE_REQUEST' });
				await BillService.delete(bill._id);
				dispatch({ type: 'DELETE_SUCCESS' });
				toast.success(t('msg.billDeletedCap'));
			} catch (err) {
				toast.error(getError(err));
				dispatch({ type: 'DELETE_FAIL' });
			}
		}
	}

	async function editPaymentHandler(bill) {
		navigate(`/AdminScreen/bills/editBill/${bill._id}`);
	}
	async function seeDetails(bill) {
		navigate(`/AdminScreen/bills/bill/${bill._id}`);
	}
	async function newPaymentHandler() {
		navigate('/AdminScreen/newBill');
	}
	async function confirmPayment(bill) {
		navigate(`/AdminScreen/bills/confirmPayment/${bill._id}`);
	}
	return loading ? (
		<DetailPageLoader entityLabel='gastos' />
	) : error ? (
		<MessageBox variant='danger'>{error}</MessageBox>
	) : (
		<div>
			<Helmet>
				<title>{`Lista de ${t('entity.bill.plural')}`}</title>
			</Helmet>

			<div className='container admin-con'>
				<div className='row adminProdBtnRow align-items-center'>
					{/* <button className='btn btn-info btn-prod-admin'><FaFilter></FaFilter>Filtrar</button> */}
					{/* <button className='btn btn-danger btn-prod-admin'><Link to='/AdminScreen/AgregarProducto'><FaPlusCircle></FaPlusCircle>Agregar Productos</Link></button> */}
				</div>
				<div>
					<Row style={{ margin: '5% 0 2.5%' }}>
						<Col>
							<h1 className='text-right'>
								<MdAttachMoney></MdAttachMoney>{`Lista de ${t('entity.bill.plural')}`}
							</h1>
						</Col>
						<Col
							style={{
								display: 'flex',
								justifyContent: 'flex-end',
							}}
						>
							<Button
								className='btn btn-dark m-2'
								value='Crear Cuenta'
								onClick={() => newPaymentHandler()}
							>
								{`Agregar ${t('entity.bill')}`}
							</Button>
						</Col>
					</Row>
					<Table bordered hover responsive size='sm'>
						<thead>
							<tr>
								<th>{t('field.idShort')}</th>
								<th>{t('field.name')}</th>
								<th>{t('field.amount')}</th>
								<th>{t('field.expirationDate')}</th>
								<th>{t('field.active')}</th>
								<th>{t('entity.account')}</th>
								<th>{t('field.type')}</th>
								<th>{t('field.periodicity')}</th>
								<th>{t('field.period')}</th>
								<th>{t('field.folder')}</th>
								<th>{t('entity.payment')}</th>
								<th className='col-1'>{t('field.options')}</th>
							</tr>
						</thead>
						{bills
							? currentPosts.map((bill) => (
								<tbody key={bill._id}>
									<tr key={bill._id}>
										<td>
											<Link to={`bill/${bill._id}`}>{bill.customId}</Link>
										</td>
										<td>
											<Link to={`bill/${bill._id}`}>{bill.name}</Link>
										</td>
										<td>{bill.amount}</td>
										<td>{bill.expirationDate.substring(0, 10)}</td>
										<td>
											<Link to={`/AdminScreen/assets/asset/${bill.asset._id}`}>
												{bill.asset.name}
											</Link>
										</td>
										{bill.asset.owner ? (
											<td>
												<Link to={`/AdminScreen/accounts/account/${bill.asset.owner._id}`}>
													{bill.asset.owner.name}
												</Link>
											</td>
										) : (
											<td></td>
										)}
										<td>{bill.type}</td>
										<td>{bill.periodicity}</td>
										{bill.period ? (
											<td>
												{bill.periodicity === 'Anual'
													? moment().year(bill.period).format('YYYY')
													: moment(bill.period).format('MM-YYYY')}
											</td>
										) : (
											<td></td>
										)}
										<td>{bill.folder}</td>
										{bill.paid || bill.confirmed ? (
											<td>
												{t('msg.confirmedLower')}{' '}
												{bill.comprobante && bill.comprobante.fileLink && (
													<Link
														style={{ fontSize: '10px' }}
														to=''
														onClick={() => verComprobante(bill)}
													>
														{t('action.viewReceiptLower')}
													</Link>
												)}
											</td>
										) : (
											<td>{t('msg.noLower')}</td>
										)}
										<td>
											<div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
												<Button
													variant='success'
													size='sm'
													onClick={() => confirmPayment(bill)}
													disabled={bill.paid || bill.confirmed}
												>
													{t('action.confirmPayment')}
												</Button>
												<DropdownButton drop='start' title=''>
													<Dropdown.Item eventKey='0' onClick={() => seeDetails(bill)}>
														{t('action.viewDetails')}
													</Dropdown.Item>
													<Dropdown.Item 
														eventKey='1' 
														onClick={() => confirmPayment(bill)}
														disabled={bill.paid || bill.confirmed}
													>
														{t('action.confirmPayment')}
													</Dropdown.Item>
													<Dropdown.Item eventKey='2' onClick={() => editPaymentHandler(bill)}>
														{t('action.edit')}
													</Dropdown.Item>
													<Dropdown.Item eventKey='3' onClick={() => deletePaymentHandler(bill)}>
														{t('action.delete')}
													</Dropdown.Item>
												</DropdownButton>
											</div>
										</td>
									</tr>
								</tbody>
							))
							: ''}
					</Table>
					<Pagination
						postsPerPage={postsPerPage}
						totalPosts={bills.length}
						paginate={paginate}
					></Pagination>
				</div>
			</div>
		</div>
	);
}

export default BillsList;
